import { APP_STATE_ACTIONS } from './app-state.actions';
import { DEFAULT_APP_STATE, IAppState } from './app-state.model';
import { ISubstateAction } from './state-actions';

export const appReducer = (state: IAppState = DEFAULT_APP_STATE, action: ISubstateAction<APP_STATE_ACTIONS>): IAppState => {
	switch (action.type) { }

	return state;
};
